import dayjs, { Dayjs } from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import { DATE_FORMATS } from '../constants';

dayjs.extend(customParseFormat);

/**
 * Attempts to parse a date string using multiple formats
 * Returns null if the input cannot be parsed into a valid date
 */
export const parseUserDateInput = (input: string, locale: string): Dayjs | null => {
  if (!input || input.trim() === '') return null;

  const trimmedInput = input.trim();

  // Try parsing with each format (strict mode enabled)
  for (const formatStr of DATE_FORMATS) {
    const parsed = dayjs(trimmedInput, formatStr, true);
    if (parsed.isValid()) {
      // Apply locale if needed (for month names, etc.)
      return locale === 'de' ? parsed.locale('de') : parsed;
    }
  }

  // Try ISO and native parsing as last resort
  const isoParsed = dayjs(trimmedInput);
  if (isoParsed.isValid()) {
    return locale === 'de' ? isoParsed.locale('de') : isoParsed;
  }

  return null;
};
